import { InternalToolsInspectRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/internal-tools/inspect')({
  component: InternalToolsInspectRoute,
});
